import React from 'react'
import PropTypes from 'prop-types'

import { Image } from '../utils/lazyImage'
import AstRenderer from '../utils/renderAst'

import ReadMore from '../global/readMore'

// import rehypeReact from 'rehype-react'

// const BGImage = props => <Image sizes={props} />

// const renderAst = new rehypeReact({
//   createElement: React.createElement,
//   components: {
//     'bg-image': BGImage,
//   },
// }).Compiler

import Styles from '../../styles/components/person.module.scss'
const {
  person,
  personPhoto,
  personMeta,
  personData,
  personTitle,
  personName,
  personDescription,
  readMore,
} = Styles

class Person extends React.Component {
  render() {
    const { image, name, title, description, path, main } = this.props

    const NameElem = main ? 'h1' : 'h2'

    return (
      <div className={person}>
        {image && (
          <div className={personPhoto}>
            {' '}
            <Image sizes={image} />
          </div>
        )}
        <div className={personMeta}>
          <NameElem className={personName}>{name}</NameElem>
          <div className={personData}>
            <div className={personTitle}>{title}</div>
            <div
              className={personDescription}
              // dangerouslySetInnerHTML={{ __html: description }}
            >
              {/* {renderAst(description)} */}
              <AstRenderer ast={description} />
            </div>
            {path && <ReadMore className={readMore} link={path} large />}
          </div>
        </div>
      </div>
    )
  }
}

export default Person



// WEBPACK FOOTER //
// ./src/components/team/person.js